import { spacing } from '@mui/system'
import styled from '@emotion/styled'

const ResponsiveDiv = styled.div`
  ${spacing}
`

export default ResponsiveDiv
